module.exports = __webpack_public_path__ + "img/step25_a_stand_power_pull_out_basket_fabric_open_velcro.cc97fc67.png";